import * as yup from 'yup';
import { UserErrorMessages, UserValidation } from '../../../../types';

export interface ArrayValidation extends Pick<UserValidation, 'required' | 'min' | 'max'> {}

// build validation for arrays
export const buildArrayValidators = (
  { required, min, max }: ArrayValidation,
  errorMessages?: UserErrorMessages,
  subSchema?: yup.Schema<any, object>,
  hasBuiltIn?: boolean
) => {
  let schema: any = yup.array(subSchema ?? undefined);
  if (hasBuiltIn) {
    return schema;
  }
  if (required) schema = schema.required(...required).nullable();
  if (min) schema = schema.min(Number(min[0]), min[1]).nullable();
  if (max) schema = schema.max(Number(max[0]), max[1]).nullable();
  return schema;
};
